<ng-container *ngIf="isReady()" id="results-wrapper">
</ng-container>
<ng-container *ngIf="!isReady()">
  <span>Aucun résultat...</span>
</ng-container>
